import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { isAuthenticated } from "./tokenHelpers";
import { fetchCurrentUser } from "../store/slices/currentUserSlice";
import { fetchAccessibleModules } from "../store/slices/accessibleModulesSlice";
import type { RootState, AppDispatch } from "../store/store";

export const ProtectedRoute: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const { data: user, loading: userLoading } = useSelector(
    (s: RootState) => s.currentUser
  );
  const { data: modules, loading: modulesLoading } = useSelector(
    (s: RootState) => s.accessibleModules
  );
  const authed = isAuthenticated();

  // Cover the "cookie exists but store is empty" case
  // (page refresh, fresh tab, or cookie carried over from buyer).
  useEffect(() => {
    if (!authed) return;
    if (!user && !userLoading) dispatch(fetchCurrentUser());
    if (!modules && !modulesLoading) dispatch(fetchAccessibleModules());
  }, [authed, user, userLoading, modules, modulesLoading, dispatch]);

  if (!authed) {
    // Only preserve a redirect when the user was aiming at a real page.
    // `/` just bounces to `/home`, so storing it adds noise (?redirect=%2F)
    // for no benefit.
    const path = location.pathname;
    const isMeaningfulPath = path && path !== "/" && path !== "/home";
    const dest = isMeaningfulPath
      ? `/login?redirect=${encodeURIComponent(path + location.search)}`
      : "/login";
    return <Navigate to={dest} replace />;
  }
  return <Outlet />;
};
